// CSS classes for drayage related milestone
export enum ReservationStatusClasses {
  complete = 'text-green-500',
  none = 'default', // default color
  partial = 'text-orange-500'
}
